import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { ChevronLeft } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import ChevronRight from 'sushiweb/Icons/all/ChevronRight';
import { P } from 'sushiweb/Typography';
import { ChevronWrapper, PaginationWrapper } from './styles';

const CustomTablePagination = ({
  currentPage,
  keyStack,
  rowsPerPage,
  currentTotalRows,
  onPrevPage,
  onNextPage,
  canNextPage,
  dataLoading,
}) => {
  const goToPreviousPage = () => {
    if (keyStack.length > 0) {
      onPrevPage();
    }
  };
  const goToNextPage = () => {
    if (canNextPage) {
      onNextPage();
    }
  };

  return (
    <PaginationWrapper>
      <P>
        {(currentPage - 1) * rowsPerPage + 1}
        -
        {currentPage * rowsPerPage - (rowsPerPage - currentTotalRows)}
        {' '}
        of
        {' '}
        {dataLoading ? (
          <Spinner size='small' />
        ) : (
          `${
            canNextPage
              ? 'many'
              : currentPage * rowsPerPage - (rowsPerPage - currentTotalRows)
          }`
        )}
      </P>
      <ChevronWrapper>
        <ChevronLeft
          showPointer={keyStack.length > 0}
          onClick={goToPreviousPage}
          size={22}
          iconName='Previous Page'
          color={`${keyStack.length > 0 ? `${grey.z800}` : `${grey.z400}`}`}
        />
      </ChevronWrapper>
      <ChevronWrapper>
        <ChevronRight
          showPointer={canNextPage}
          onClick={goToNextPage}
          size={22}
          iconName='Next Page'
          color={`${canNextPage ? `${grey.z800}` : `${grey.z400}`}`}
        />
      </ChevronWrapper>
    </PaginationWrapper>
  );
};

CustomTablePagination.propTypes = {
  currentPage: PropTypes.number,
  keyStack: PropTypes.arrayOf(PropTypes.any),
  rowsPerPage: PropTypes.number,
  currentTotalRows: PropTypes.number,
  onPrevPage: PropTypes.func,
  onNextPage: PropTypes.func,
  canNextPage: PropTypes.bool,
  dataLoading: PropTypes.bool,
};

CustomTablePagination.defaultProps = {
  currentPage: 1,
  keyStack: [],
  rowsPerPage: 10,
  currentTotalRows: 10,
  onPrevPage: _noop,
  onNextPage: _noop,
  canNextPage: true,
  dataLoading: false,
};

export default CustomTablePagination;
